import { render, staticRenderFns } from "./GenericGutter.vue?vue&type=template&id=635a905b&scoped=true"
import script from "./GenericGutter.vue?vue&type=script&lang=js"
export * from "./GenericGutter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a905b",
  null
  
)

export default component.exports